export default __webpack_public_path__ + "static/media/Star.b4e4d3d7.svg";